import { render, staticRenderFns } from "./BitrixApp.vue?vue&type=template&id=4ade973a&scoped=true"
import script from "./BitrixApp.vue?vue&type=script&lang=js"
export * from "./BitrixApp.vue?vue&type=script&lang=js"
import style0 from "./BitrixApp.vue?vue&type=style&index=0&id=4ade973a&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ade973a",
  null
  
)

export default component.exports